/* eslint-disable react/no-unknown-property */
/* eslint-disable @next/next/no-img-element */
import React, { useState } from 'react';
import Styles from './DenFraudesMudancaRazaoSocial.css';
import RedButton from '../../atoms/RedButton/RedButton';
import ContainerHome24 from '@/components/atoms/ContainerHome24';

function DenFraudesMudancaRazaoSocial() {
  const [width, setWidth] = useState(typeof window === 'undefined' ? 0 : window.window.innerWidth);
  if (typeof window === 'undefined') {
    console.log('');
  } else {
    window.addEventListener('resize', function () {
      setWidth(window.window.innerWidth);
    });
  }

  return (
    <>
      <section id="den-fraudes-mudanca-razao-social">
        <ContainerHome24>
          {typeof window === 'undefined' ? (
            <></>
          ) : (
            <>
              {width <= 992 && (
                <img
                  src="assets/denuncias-e-fraudes/img-mudanca-razao-social.svg"
                  alt=""
                  className="img-mudanca-razao-social"
                />
              )}
              {width > 992 && (
                <img
                  src="assets/denuncias-e-fraudes/img-mudanca-razao-social-desk.svg"
                  alt=""
                  className="img-mudanca-razao-social"
                />
              )}
            </>
          )}

          <div className="den-fraudes-mudanca-razao-social-textos">
            <h3 className="mudanca-razao-social-titulo">
              Nossa razão social foi atualizada. Veja o que muda para você:
            </h3>
            <p className="mudanca-razao-social-texto">
              Agora somos <b>Santander Sociedade de Crédito, Financiamento e Investimento S.A.</b>{' '}
              Essa mudança é apenas institucional e não altera seus contratos, condições ou
              pagamentos. Os boletos já emitidos em nome de{' '}
              <b>AYMORÉ CRÉDITO, FINANCIAMENTO E INVESTIMENTO S.A.</b> continuam válidos, e você não
              precisa fazer nada.
              <br />
              <br />
              Para sua segurança, confira sempre as informações do boleto:
              <br />• O <b>CNPJ do beneficiário (07.707.650/0001-10)</b> e o{' '}
              <b>código do boleto (033)</b> permanecem os mesmos
              <br />
              • Utilize apenas nossos canais oficiais.
              <br />
              <br />
              Conte com a gente. Seguimos ao seu lado, com a solidez e a segurança que você já
              conhece.
            </p>
          </div>
        </ContainerHome24>
      </section>

      <style jsx>{Styles}</style>
    </>
  );
}

export default DenFraudesMudancaRazaoSocial;
